import { hasPriceValue } from '../../helpers'
import { Identificator, ILanguage, IVisitType } from '../../store/data'

export const getVisitTypesFilter = (data: IVisitType[], language: ILanguage): IVisitType[] =>
  data.filter((item) => hasPriceValue(item.lowest_price, 'amount_per_night', language))

export const isVisitTypeSelectableForHotel = (
  visitType: IVisitType,
  hotelId: Identificator | null,
  language: ILanguage
) => {
  if (!hotelId) {
    return false
  }

  const selectedHotel = visitType.hotels.find((hotel) => Number(hotel.id) === Number(hotelId))

  if (!selectedHotel) {
    return false
  }

  return hasPriceValue(selectedHotel.lowest_price, 'amount_per_night', language)
}

export const getVisitTypesForHotelFilter = (
  data: IVisitType[],
  hotelId: Identificator | null,
  language: ILanguage
): IVisitType[] => {
  if (!hotelId) {
    return []
  }

  return data.filter((item) => isVisitTypeSelectableForHotel(item, hotelId, language))
}
